var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AF6A34",
    d: "M8.536 1.57H7.464q-.143 0-.143.143V7.32h-5.32q-.144 0-.144.143v1.072q0 .142.143.142h5.321v5.608q0 .143.143.143h1.072q.142 0 .142-.143V8.677H14q.143 0 .143-.142V7.463q0-.143-.143-.143H8.678V1.713q0-.143-.142-.143"
  })));
};
export default SvgPlus;